import { HashTable } from "../HashTable";

function SocketDelegate() {
  this.eventList = new HashTable(); //回调函数列表
  this.add = function(target, callBack) {
    this.eventList.add(target, callBack);
  };

  this.remove = function(target) {
    this.eventList.remove(target);
  };

  this.run = function(params) {
    for (var k in this.eventList.table) {
      try {
        var func = this.eventList.table[k];
        //if (typeof func == "function") {
        if (func != undefined) func(params); // 遍历所有方法以及调用
        //}
      } catch (e) {
        continue;
      }
    }
  };

  //this.add(func);
}



export { SocketDelegate };
